import React from 'react';

import CurrencyFormat from '../../../../../../../components/CurrencyFormat';
import PriceDetailsItem from '../../../../PriceDetailsItem';
import type { Item } from '../../../types';

const FlightSummaryItem = ({ name, price, tooltipText }: Item) => (
  <PriceDetailsItem label={name} tooltipText={tooltipText}>
    <CurrencyFormat value={price} />
  </PriceDetailsItem>
);

export default FlightSummaryItem;
